import React from "react";
import {
  ArtImage,
  CTAContainer,
  ImageContainer,
  MainContainer,
} from "./styles";
import Art from "../../assets/png/artBackground/art2.png";
import Typography from "../../components/Typography";
import { Column } from "../../themes/globalStyle";
import Button from "../../components/Button";
import useAuth from "../../hooks/useAuth";

const Trial: React.FC = (): JSX.Element => {
  const { logout } = useAuth();

  return (
    <MainContainer>
      <ImageContainer>
        <ArtImage src={Art} />
        <Column style={{ width: "36rem", textAlign: "center", gap: "2rem" }}>
          <Typography
            text="Em breve entraremos em contato para liberar o seu acesso! 🥳"
            size="extraHuge"
            color="Black500"
            weight={400}
          />
          <Typography
            text="Na fase Beta as liberações ainda estão acontecendo manualmente."
            size="medium"
            color="Black400"
            weight={300}
          />
          <Typography
            text="Se você quiser adiantar o processo... É só preencher nosso formulário de lista VIP clicando no botão abaixo."
            size="medium"
            color="Black400"
            weight={300}
          />
          <Button
            onClick={() => window.open("https://forms.gle/pd9Vgug1EL69QSJGA")}
          >
            Entrar na lista VIP
          </Button>
          <CTAContainer
            onClick={() =>
              window.open(
                "https://api.whatsapp.com/send/?phone=%2B16609002204&text=Oii%2C%20estou%20vindo%20da%20plataforma%20CoProdux.%20Gostaria%20de%20tirar%20uma%20d%C3%BAvida.%20Meu%20nome%20%C3%A9%3A%20[SEU%20NOME]&type=phone_number&app_absent=0"
              )
            }
          >
            <Typography
              text="Entrar em contato"
              size="medium"
              color="Blue300"
              weight={400}
            />
          </CTAContainer>
          <CTAContainer onClick={() => logout()}>
            <Typography
              text="Logout"
              size="medium"
              color="Blue300"
              weight={400}
            />
          </CTAContainer>
        </Column>
      </ImageContainer>
    </MainContainer>
  );
};

export default Trial;
